import React, { useEffect, useState } from 'react'

import { toast } from 'react-toastify';
import axios from 'axios';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import { Button } from '@mui/material';
import { Delete, Edit, Visibility } from '@mui/icons-material';
import { deleteMetaPagesDetail, getMetaPagesDetail } from 'Services/Meta/MetaDetails';
import { useMutation, useQuery } from 'react-query';

const MetaDetails = () => {
    const { id } = useParams()

    const navigate = useNavigate();


    const { data, refetch } = useQuery(["metapages-detail", id], () => getMetaPagesDetail({ meta_pages: id }))

    const { mutate: DeleteMetaPages } = useMutation(deleteMetaPagesDetail, {
        onSuccess: (res) => {

            if (res?.data?.response_code === 200) {
                toast.success(res?.data?.message)
                refetch()
            }
            else {
                toast.warn(res?.data?.message)
            }
        }
    })




    return (
        <div>
            <p className="my-3 text-5xl text-center text-blue-900 underline">Meta</p>
            <div className="flex justify-end item-center w-[100%]">
                <NavLink to={`/metadetails/${id}/add`}>
                    <div className="text-xl font-bold !text-gray-600 p-3 pr-[10%]">
                        <Button variant="outlined">Add</Button>
                    </div>
                </NavLink>
            </div>
            <div className="overflow-x-auto max-w-screen">
                <table className="min-w-full border border-collapse border-gray-300 table-auto">
                    <thead>
                        <tr className="bg-gray-100 ">
                            <th className="px-4 py-2 text-lg font-semibold text-left text-black">Meta Title</th>
                            <th className="px-4 py-2 text-lg font-semibold text-left text-black">Meta Description</th>
                            <th className="flex justify-center px-20 py-2 text-lg font-semibold text-left text-black">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.data?.data?.map((item) => (
                            <tr key={item.id} className="border-b border-gray-300">
                                <td className="px-4 py-2 overflow-hidden text-lg text-black text-ellipsis">
                                    <p >{item.meta_title}</p>
                                </td>
                                <td className="px-4 py-2 overflow-hidden text-lg text-black text-ellipsis ">
                                    <p>{item?.meta_description}</p>
                                </td>
                                <td className="px-4 py-2 overflow-hidden text-lg text-black whitespace-nowrap text-ellipsis">
                                    <div className="flex justify-center space-x-4">
                                        <Button
                                            startIcon={<Edit className='!text-green-600' />}
                                            onClick={() => navigate(`/metadetails/${id}/update`, { state: item.id })}
                                            variant="outlined"
                                        >
                                            Update
                                        </Button>
                                        <Button
                                            startIcon={<Delete className='!text-red-500' />}
                                            onClick={() => DeleteMetaPages({ details_id: item.id })}
                                            variant="outlined"
                                        >
                                            Delete
                                        </Button>
                                        <Button
                                            onClick={() => navigate(`/metadetails/${id}/view`, { state: item.id })}
                                            variant="outlined"
                                            startIcon={<Visibility />}
                                        >
                                            View
                                        </Button>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>


                </table>
            </div>

        </div>
    )
}

export default MetaDetails